module.exports = __webpack_public_path__ + "res/15-img_game_bg_t.7266ce9ad87e6b7a1b3a555c3b6881c8.png";